import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SnackbarAlertComponentModule } from "./components/snackbar-alert/snackbar-alert.component";
import { CountdownSnackbarComponentModule } from "./components/countdown-snackbar/countdown-snackbar.component";
import { ToastMessageComponentModule } from "./components/toast-message/toast-message.component";
import { QrCodeComponentModule } from "./components/qr-code/qr-code.component";
import { TokenPaginatorComponentModule } from "./components/token-paginator/token-paginator.component";
import { LoadingDialogComponentModule } from "./components/loading-dialog/loading-dialog.component";
import { InfoDialogComponentModule } from "./components/info-dialog/info-dialog.component";
import { SearchBarComponentModule } from "./components/search-bar/search-bar.component";
import { SearchableSelectorComponentModule } from "./components/searchable-selector/searchable-selector.component";

@NgModule({
  imports: [CommonModule],
  exports: [
    SnackbarAlertComponentModule,
    CountdownSnackbarComponentModule,
    ToastMessageComponentModule,
    QrCodeComponentModule,
    TokenPaginatorComponentModule,
    LoadingDialogComponentModule,
    InfoDialogComponentModule,
    SearchBarComponentModule,
    SearchableSelectorComponentModule,
  ],
})
export class CoreModule {}
